// dependencies
import React from "react";
import { ColorShade } from "react/app/Theme";

import { faCircleCheck, faCircleExclamation, faCircleInfo } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { getColor } from "../../utils/getColor";

// components
import Text from "../Text";
// styles
import css from "./Alert.module.scss";

interface BaseProps {
	/**
	 * The message to display in the alert
	 */
	message: string;
	/**
	 * The type of alert to display
	 */
	type: "error" | "success" | "neutral";
	/**
	 * Optional class name to add to the alert
	 */
	className?: string;
}

const icons = {
	error: faCircleExclamation,
	success: faCircleCheck,
	neutral: faCircleInfo,
};

const colors: {
	[key: string]: { shade: ColorShade; hex: ReturnType<typeof getColor> };
} = {
	error: { shade: "red-6", hex: getColor("red", 5) },
	success: { shade: "green-5", hex: getColor("green", 5) },
	neutral: { shade: "neutral-5", hex: getColor("neutral", 5) },
};

/**
 * Primary UI component for displaying alerts to the user
 * @deprecated Use the Alert component from the py-components package instead
 */
const Alert = (props: BaseProps) => {
	const { message, type, className = "" } = props;

	return (
		<div className={`${className} ${css.errorAlertContainer}`} role="alert">
			<FontAwesomeIcon
				className={css.icon}
				color={colors[type].hex}
				icon={icons[type]}
				data-testid={type === "error" ? "circle-exclamation" : "circle-check"}
			/>
			<Text
				className={css.message}
				element="span"
				size="paragraph-3"
				weight="semi-bold"
				color={colors[type].shade}
			>
				{message}
			</Text>
		</div>
	);
};

export default Alert;
